import userMiddleware from "@/components/search/ducks/middleware"
import internalMiddleware from "@/components/search/internal/ducks/middleware"

export default [internalMiddleware, userMiddleware]
